import mitt from "mitt";
import Util from "@/helper/Utility.js";
/**
 * setting
 * @method setMsg
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onClickOk
 * event
 * @event sendCallbackOk
 */
export function RegisterSuccessModalController () {
    this.msg = '';
    this.busModal = mitt();

    this.callbackOk = null;

    //#region setter
    this.clearModal = function() {
        this.msg = '';
        this.callbackOk = null;
        return this;
    };
    this.setMsg = function(msg) {
        this.msg = msg;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            msg: this.msg,
        };
        this.busModal.emit('show', config);
    };
    this.hide = function() {
        this.busModal.emit('hide');
    };
    //#endregion method

    //#region event
    this.onClickOk = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackOk = callback;
        }
    },
    this.sendCallbackOk = function(data) {
        if (Util.isFunction(this.callbackOk)) {
            this.callbackOk(data);
        }
    };
    //#endregion event
}
